import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";
import toast from "react-hot-toast";
import { Plus, Trash2, Edit, Loader2 } from "lucide-react";

export default function BlogListPage() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const res = await api.get("/blog");
      setBlogs(res.data || []);
    } catch { toast.error("Bloglar yüklenemedi"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchBlogs(); }, []);

  const handleDelete = (id) => {
    if (!window.confirm("Bu blogu silmek istediğinize emin misiniz?")) return;
    api.delete(`/blog/${id}`)
      .then(() => { toast.success("Blog silindi"); fetchBlogs(); })
      .catch(() => toast.error("Silme işlemi başarısız"));
  };

  if (loading) return <div className="page-loading"><div className="loading-spinner" /><p>Yükleniyor...</p></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Bloglar</h2>
          <p className="page-subtitle">{blogs.length} blog yazısı</p>
        </div>
        <Link to="/blog-add" className="btn btn-primary"><Plus size={18} /> Yeni Blog</Link>
      </div>

      <div className="content-card no-padding">
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>Resim</th>
                <th>Başlık (TR)</th>
                <th>Yazar</th>
                <th>Okuma Süresi</th>
                <th>SSS</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((blog) => (
                <tr key={blog.blogId}>
                  <td>
                    {blog.imageUrl ? (
                      <img src={blog.imageUrl} alt="" className="table-thumb" />
                    ) : (
                      <div className="table-thumb-placeholder" />
                    )}
                  </td>
                  <td className="fw-medium">{blog.titleTr}</td>
                  <td>{blog.author || "-"}</td>
                  <td>{blog.readingTime ? `${blog.readingTime} dk` : "-"}</td>
                  <td>{blog.blogFAQs?.length || 0}</td>
                  <td>
                    <span className={`status-badge ${blog.isActive ? "active" : "inactive"}`}>
                      {blog.isActive ? "Aktif" : "Pasif"}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link to={`/blog-add/${blog.blogId}`} className="btn-icon edit"><Edit size={16} /></Link>
                      <button onClick={() => handleDelete(blog.blogId)} className="btn-icon delete"><Trash2 size={16} /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {blogs.length === 0 && (
          <div className="empty-state">
            <p>Henüz blog yazısı eklenmemiş</p>
            <Link to="/blog-add" className="btn btn-primary"><Plus size={18} /> İlk Blogu Ekle</Link>
          </div>
        )}
      </div>
    </div>
  );
}
